import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import AccountCardConfigurator from './AccountCardConfigurator';
import withModal from '../../../../components/global/modal/withModal';
import DismissButton from '../../../../components/global/DismissButton';

export const ACCOUNT_CARD_CONFIGURATOR_MODAL =
  'modal/ACCOUNT_CARD_CONFIGURATOR';

const propTypes = {
  actionProps: PropTypes.shape({
    onClose: PropTypes.func,
    defaultCardCategoryId: PropTypes.string,
    defaultParentCardCategoryId: PropTypes.string,
    onCardSelectClose: PropTypes.func,
  }),
  onClose: PropTypes.func,
};

const AccountCardConfiguratorModal = ({
  actionProps,
  onClose: onCloseProp,
  ...props
}) => {
  const {
    onClose: onCloseAction,
    defaultCardCategoryId,
    defaultParentCardCategoryId,
    presetCardElementConfigurationInputs,
    onCardSelectClose,
  } = actionProps ?? {};
  const onClose = onCloseAction ?? onCloseProp;

  return (
    <Fragment>
      {onClose && (
        <div className="text-right mb-2">
          <DismissButton onClick={onClose} />
        </div>
      )}
      <AccountCardConfigurator
        defaultCardCategoryId={defaultCardCategoryId}
        defaultParentCardCategoryId={defaultParentCardCategoryId}
        presetCardElementConfigurationInputs={
          presetCardElementConfigurationInputs
        }
        onCardSelectClose={onCardSelectClose}
        {...props}
      />
    </Fragment>
  );
};

AccountCardConfiguratorModal.propTypes = propTypes;

export default withModal(AccountCardConfiguratorModal, {
  name: ACCOUNT_CARD_CONFIGURATOR_MODAL,
  type: 'full',
  size: 'md',
  overlayClassName: 'account-card-config-modal-overlay',
});
